import React from "react";

interface InputProps {
  text: string;
  onTextChange: (value: string) => void;
  rows: number;
  columns: number;
}

interface InputState {
}

export default class Input extends React.Component<InputProps, InputState> {

  constructor(props: InputProps) {
    super(props);
    this.state = {
      currentText: props.text
    };
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event: React.ChangeEvent<HTMLTextAreaElement>) {
    this.props.onTextChange(event.target.value);
    // this.setState({currentText: event.target.value});
  }

  render() {
    return (
      <textarea
        id="input"
        placeholder="Enter PlantUML text here"
        onChange={this.handleChange}
        rows={this.props.rows}
        cols={this.props.columns}
        value={this.props.text}
      />
    );
  }
}
